import { ReactComponent as FOOTER } from '@/assets/logo-1.svg'
import { cnTw } from '@/utils'

export default function Footer({ baseClassName = '' }: { baseClassName?: string }) {
	return (
		<div className={cnTw('relative z-10 flex flex-col items-center justify-center py-10', baseClassName)}>
			<FOOTER />
			<span className="mt-4 text-base text-white">© 2018–2025 </span>
		</div>
	)
}
